export default (idToken) => ({
  id: idToken.sub,
  name: idToken["https://almamedia.net/alias"],
  email: idToken.email || idToken["https://almamedia.net/user_email"],
  role: idToken["https://almamedia.net/user_role"],
  accountHash: idToken["https://almamedia.net/accountHash"],
  IPAccountID: idToken["https://almamedia.net/ip_account_id"] || "",
  emailVerified: idToken.email_verified,
  fromSignUp: idToken["https://almamedia.net/fromSignUp"],
  almaIDHash: idToken["https://almamedia.net/almaIDHash"],
  cdime: idToken["https://almamedia.net/cdime"],
});
